import { FlashSaleList } from 'components/flash-sale/flash-sale-list/FlashSaleList'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { getAllQueryParams, getQueryFilter, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/flash-sale/configTableFlashSaleList'
import { useEffect, useState } from 'react'
import { ACTION_TYPE } from 'constants/constant'
import { useFetch } from 'services/useFetch'
import { API_FLASH_SALE } from 'services/apiFlashSale'
import { Alert } from 'avo-ui'

const INIT_FILTER = {
    status: [],
}

export const FlashSaleListContainer = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [queryFilter, setQueryFilter] = useState({})
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [deleteId, setDeleteId] = useState(null)
    const { fetching: getFlashSaleList, data: flashSaleList, isLoading } = useFetch(API_FLASH_SALE.LIST)
    const { fetching: deleteFlashSale, isLoading: isDeleting } = useFetch(API_FLASH_SALE.DELETE)
    const [modal, setModal] = useState({
        filter: false,
        delete: false,
    })

    useEffect(() => {
        const currentQuery = { ...query }
        const newQueryFilter = { ...INIT_FILTER }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (key === 'status') {
                const valueOfQuery = item?.split(',')
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        fetchFlashSaleList(currentQuery)
    }, [location?.search])

    const onClickItemHandler = ({ id, actionType }) => {
        if (actionType === ACTION_TYPE.EDIT) {
            navigate(`/flash-sale/flash-sale-list/update-flash-sale?flashSaleId=${id}`)
        } else {
            setDeleteId(id)
            setShowModal({ delete: true })
        }
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchFlashSaleList = (item = { ...query }) => {
        getFlashSaleList(item)
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryFilter(filter)
        onChangeQuery({ ...queryFilter, page: 1 })
    }

    const onDelete = () => {
        deleteFlashSale({}, deleteId).then(() => {
            if (flashSaleList?.data?.results?.length === 1 && Number(query?.page) !== 1) {
                onChangeQuery({ page: 1 })
            } else {
                fetchFlashSaleList()
            }

            setShowModal({ delete: false })
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Flash Sale Deleted !',
            })
        })
    }

    const props = {
        dataList: flashSaleList?.data,
        query,
        queryFilter,
        onChangeQuery,
        onDelete,
        onClickItemHandler,
        onFilter,
        modal,
        setShowModal,
        isDeleting,
        isLoading,
    }

    return <FlashSaleList {...props} />
}
